import { atom } from "jotai";
import { AuthAtom } from "./type";

const initialState: AuthAtom = {
  authStatus: "authenticating",
  refetch: false,
};

export const authAtom = atom(initialState);
